import { FC } from 'react'

import styled from 'styled-components'

import { PrimaryAlert } from 'src/Components/PrimaryAlert'
import { variables } from 'src/Styled/variables'

const StyledPrimaryAlert = styled(PrimaryAlert)`
  width: 358px !important;
  @media (min-width: 768px) {
    width: 344px !important;
  }
`

const Title = styled.div`
  font-family: 'Segoe UI';
  font-style: normal;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
`

const Text = styled.div`
  font-family: 'Segoe UI';
  font-style: normal;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  margin-top: 4px;
`

export interface LowBudgetContentProps {
  onClose: () => void
}

export const LowBudgetContent: FC<LowBudgetContentProps> = ({ onClose }) => (
  <StyledPrimaryAlert type={'warning'} hasCross onClose={onClose}>
    <Title>Low-budget zone</Title>
    <Text>
      Campaigns below $350 often underperform. To give your track the best shot,
      we recommend increasing the budget.
    </Text>
  </StyledPrimaryAlert>
)
